import { useState } from "react";
import { EditIcon } from "@chakra-ui/icons";
import {
  Flex,
  Heading,
  ListItem,
  Menu,
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import Link from "components/Shared/Link";
import MoreMenuButton from "components/Shared/MoreMenuButton";
import SyncIndicator from "components/Shared/SyncIndicator";
import { customerPage } from "utils/links";
import DeleteMenuItem from "components/Customers/CustomerPage/ProductDetails/DeleteMenuItem";
import SkuOrderingPlatformItemContainer from "./ItemContainer";
import SkuOrderingPlatformEdit from "./Edit";
import SkuOrderingPlatformView from "./View";

const fragment = gql(/* GraphQL */ `
  fragment SkuPanelSkuBrandOrderingPlatform on SkuBrandOrderingPlatform {
    id
    orderingPlatform {
      id
      name
    }
    analyticsSyncDetails {
      ...SyncIndicator
    }
    ...DeleteSkuBrandOrderingPlatformMenuItem
    ...ViewSkuBrandOrderingPlatform
    ...EditSkuOrderingPlatform
  }
`);

type Props = {
  skuBrandOrderingPlatform: FragmentType<typeof fragment>;
};

export default function SkuOrderingPlatformItem({
  skuBrandOrderingPlatform: skuBrandOrderingPlatformFragment,
}: Props) {
  const [isEditing, setIsEditing] = useState(false);

  const sbop = getFragmentData(fragment, skuBrandOrderingPlatformFragment);
  const op = sbop.orderingPlatform;

  return (
    <SkuOrderingPlatformItemContainer as={ListItem} key={sbop.id}>
      <Flex>
        <Heading size="xs" color="magenta.dark">
          <Link href={isEditing ? undefined : customerPage(op?.id)}>
            {op?.name}
          </Link>
          <SyncIndicator analyticsSyncDetails={sbop?.analyticsSyncDetails} />
        </Heading>

        <Menu>
          <MoreMenuButton
            aria-label="Actions"
            size="md"
            px=".2em"
            py=".2em"
            ml="auto"
            mt="-.1em"
            mr="-.2em"
            isDisabled={isEditing}
          />
          <MenuList fontSize="md">
            <MenuItem icon={<EditIcon />} onClick={() => setIsEditing(true)}>
              Edit Details…
            </MenuItem>

            <MenuDivider />

            <DeleteMenuItem
              skuBrandOrderingPlatform={sbop}
              label="Remove Customer"
            />
          </MenuList>
        </Menu>
      </Flex>

      {isEditing ? (
        <SkuOrderingPlatformEdit
          skuBrandOrderingPlatform={sbop}
          onCancel={() => setIsEditing(false)}
          onCompleted={() => setIsEditing(false)}
        />
      ) : (
        <SkuOrderingPlatformView skuBrandOrderingPlatform={sbop} />
      )}
    </SkuOrderingPlatformItemContainer>
  );
}
